/**
 * PATCH ρυθμίσεων καταστήματος (take away / delivery). ok=false σε 4xx/5xx ή χωρίς δίκτυο — τότε
 * το UI γυρίζει πίσω την τιμή και λέει γιατί (πριν: ο διακόπτης έμενε στη λάθος θέση σιωπηλά).
 */
export type PatchResult<T> = { ok: true; data: T } | { ok: false; status: number };

export async function patchSettings<T>(url: string, body: Record<string, unknown>): Promise<PatchResult<T>> {
  try {
    const response = await fetch(url, {
      method: 'PATCH',
      headers: {
        Authorization: `Bearer ${localStorage.getItem('xentrix_token')}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body),
    });
    if (!response.ok) return { ok: false, status: response.status };
    return { ok: true, data: (await response.json()) as T };
  } catch {
    return { ok: false, status: 0 };
  }
}
